import httpClient from "..";
import { API_ENDPOINTS } from "../endpoints";
import type { BaseLogEvent } from "./logger-core";

export async function sendLogs(logList: BaseLogEvent[], instanceId?: string) {
  const config = {
    headers: {
      "Accept-Version": "1.0",
      "Content-Type": "application/json",
      ...(instanceId ? { instanceId } : {}),
    },
  };
  return httpClient
    .post(API_ENDPOINTS.LOGS, { logList }, config)
    .then((res) => res.data);
}
